import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    card: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 177,
        padding: '24px 20px 16px',
        backgroundColor: '#F2E3E6',
    },
    topTitle: {
        lineHeight: 1.2,
        marginTop: -11,
        width: '102%',
        marginBottom: 7,
        color: '#a8a8a8',
    },
    heading: {
        flex: 1,
        marginBottom: theme.spacing(2),
    },
    value: {
        fontFamily: 'Lato-Light',
        fontSize: 61,
        lineHeight: '61px',
        color: '#710626',
    },
    levelTitle: {
        fontFamily: 'Lato-Bold',
        textTransform: 'uppercase',
        color: '#232221',
        marginBottom: 3,
    },
    levelIcon: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    label: {
        fontFamily: 'Lato-Light',
        fontSize: 28,
        lineHeight: '34px',
        marginBottom: 5,
        marginLeft: 8,
    },
}));
